import { createContext, useContext } from 'react'

import type { UserDetailsResponse } from '@/utils/api/user-service/models'

export interface TAuthContext {
  user: UserDetailsResponse | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (user: UserDetailsResponse) => void
  logout: () => void
}

export const AuthContext = createContext<TAuthContext | undefined>(undefined)

export function useAuth(): TAuthContext {
  const ctx = useContext(AuthContext)
  if (!ctx)
    throw new Error('useAuth must be used within an AuthProvider')
  return ctx
}
